// /welcome — public landing page.
//
// Where unauthenticated visitors arrive when they hit /. Tone matches the
// rest of the product: institutional, plain, restrained. Both paragraphs
// echo the framing used in docs/ai-use-statement.md so the voice is
// consistent across the public surface (welcome page + governance page).

import { Link } from '@tanstack/react-router';

export default function WelcomePage() {
  return (
    <div className="min-h-full flex flex-col bg-white">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-0 focus:left-0 focus:p-2 focus:bg-white focus:z-50"
      >
        Skip to main content
      </a>
      <header className="h-14 border-b border-neutral-200 flex items-center px-4 shrink-0">
        <div className="flex items-baseline gap-1.5" aria-label="Granted, by Commondoor">
          <span className="font-semibold text-accent">Granted</span>
          <span className="text-xs text-neutral-500">by Commondoor</span>
        </div>
      </header>

      <main id="main" className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="max-w-xl w-full text-center space-y-6">
          <h1 className="text-4xl font-semibold tracking-tight text-neutral-900">Granted</h1>
          <p className="text-lg text-neutral-700">
            Grant intelligence for District Social Services Administration Boards.
          </p>

          <div className="space-y-3 text-neutral-700 text-base leading-relaxed text-left mx-auto max-w-md">
            <p>
              Granted ingests verified grant programs from federal, provincial,
              regional and Indigenous funders, matches each to a partner
              profile with cited reasoning, and tracks the full application
              lifecycle.
            </p>
            <p>
              It does not invent grants, submit applications, or make funding
              decisions. Every claim is sourced; every record is reviewed by a
              human before it goes live.
            </p>
          </div>

          <div className="pt-2 flex flex-col items-center gap-3">
            <Link
              to="/login"
              className="inline-flex items-center justify-center bg-accent text-white rounded-md px-5 py-2 text-sm font-medium hover:bg-accent-hover"
            >
              Sign in
            </Link>
            <Link to="/governance" className="text-sm text-accent underline">
              Read AI Use Statement →
            </Link>
          </div>
        </div>
      </main>

      <footer className="text-center text-xs text-neutral-500 py-4 border-t border-neutral-100">
        A product of Commondoor —{' '}
        <a
          href="https://commondoor.ca"
          className="underline hover:text-neutral-700"
          rel="noreferrer noopener"
        >
          commondoor.ca
        </a>
      </footer>
    </div>
  );
}
